import { useState,useEffect,useMemo } from "react";
import {Link,useHistory,useLocation} from "react-router-dom";
import styled from "styled-components";
import backgroundImage from '../assets/imgs/bg-1.jpg';
import LogoSRC from '../assets/imgs/Logo_portal_web.png';
import ButtonCarta from "../Components/Home/ButtonCarta";
import SocialButton from "../Components/Home/SocialButton";
import ReactGA from 'react-ga';


import ImageWhatsapp  from "../assets/imgs/SocialButtons/Whatsapp.png"
import ImageInstagram from "../assets/imgs/SocialButtons/Instagram.png"
import ImageFacebook  from "../assets/imgs/SocialButtons/Facebook.png"
import ImageMaps      from "../assets/imgs/SocialButtons/Maps.png"
import ImageWeb       from "../assets/imgs/SocialButtons/Web.png"
import useImagenes from "../Hooks/useImagenes";


const Page = styled.div`
display: grid;
justify-content: center;
align-items: center;
min-height:100vh;
background: url(${backgroundImage}) repeat 0 0;`;

const Container = styled.div``;

const Logo = styled.img`
background-color:black;
display:flex;
margin:0 auto;
width:195px;
border:2px solid rgba(106,44,0,1);
border-radius:100%;`;

const ContainerButtons = styled.div`
display: grid;
gap: 20px;
grid-template-columns: repeat(5, 1fr);
margin: 20px 0;`;

const Image = styled.img`
width:100%;`;

function useQuery() {
    const { search } = useLocation();
  
    return search.replace("?","").split("&").reduce((acc, item) => {
      const [key, value] = item.split("=");
      return {
        ...acc,
        [key]: value,
      };
    }, {});
}


const Home = () =>
{
    let history  = useHistory();
    const Params = useQuery();

    const Mesa = Params.t;

    const [ShowNovedades, setShowNovedades] = useState(false);
    const [ShowPromiciones, setShowPromiciones] = useState(false);
    const [ShowMerchandising, setShowMerchandising] = useState(false);

    const [FirstClickNovedades, setFirstClickNovedades] = useState(false);
    const [FirstShowPromiciones, setFirstShowPromiciones] = useState(false);
    const [FirstShowMerchandising, setFirstShowMerchandising] = useState(false);

    const ImagenesNovedades = useImagenes("/Novedades");
    const ImagenesPromo = useImagenes("/Promos");
    const ImagenesMerch = useImagenes("/Merchandasing");
    
    useEffect(() => 
    {
        ReactGA.initialize("UA-230105751-1");
        ReactGA.pageview("/index");
    }, [])
    
    const ClickNovedades = () =>
    {
        if(!FirstClickNovedades)
        {
            ReactGA.event("showNovedades", "showNovedades");
            setFirstClickNovedades(true);
        }
        setShowNovedades(!ShowNovedades);
    }

    const ClickPromociones = () =>
    {
        if(!FirstShowPromiciones)
        {
            ReactGA.event("showPromos", "showPromos");
            setFirstShowPromiciones(true);
        }
        setShowPromiciones(!ShowPromiciones);

        
    }

    const ClickMerchandising = () =>
    {
        if(!FirstShowMerchandising)
        {
            ReactGA.event("showMerch", "showMerch");
            setFirstShowMerchandising(true);
        }
        setShowMerchandising(!ShowMerchandising);
    }

    const ClickCarta = () =>
    {
        ReactGA.event("toCarta", "toCarta");
        history.push("/carta");
    }

    const ClickFotoMerchandasing = ()  =>
    {
        window.open("https://encasa.baumlanus.com.ar/", "_blank")
    }

    const ClickReseñas = () =>
    {
        ReactGA.event("toReview", "toReview");

        if(Mesa) 
            history.push("/reseña?t="+Mesa);
        else
            history.push("/reseña");
    }

    const ClickListaEspera = () =>
    {
        ReactGA.event("toList", "toList");

        history.push("/lista"); 
    }

    return <Page> 
    <Container>

        <a href="https://www.cervezabaum.com/">
            <Logo src={LogoSRC}/>
        </a>

        <ButtonCarta click={ClickNovedades} primary="#355e8f">NOVEDADES</ButtonCarta>
        {ShowNovedades && ImagenesNovedades.map(Imagen =>
        {
            return <Image src={Imagen.data.source} className="cont-img"/>
        })} 

        <ButtonCarta click={ClickPromociones} primary="#598841">PROMOCIONES</ButtonCarta>
        {ShowPromiciones && ImagenesPromo.map(Imagen =>
        {
            return <Image src={Imagen.data.source} className="cont-img"/>
        })} 


        <ButtonCarta click={ClickMerchandising} primary="#b14e4e">MERCHANDISING</ButtonCarta>
        {ShowMerchandising && ImagenesMerch.map(Imagen =>
        {
            return <Image onClick={ClickFotoMerchandasing} src={Imagen.data.source} className="cont-img"/>
        })} 



        <Link  className="text-decoration-none" to="/carta" > <ButtonCarta  click={ClickCarta} primary="orange" font="25px">CARTA</ButtonCarta> </Link>
        <ButtonCarta click={ClickListaEspera} primary="#6652d5">LISTA DE ESPERA</ButtonCarta>
        <ButtonCarta click={ClickReseñas} primary="#77467c" >CALIFICÁ TU VISITA! <br/> (10% off en tienda online)</ButtonCarta>

        <ContainerButtons>
            <SocialButton image={ImageWhatsapp} link="https://api.whatsapp.com/send?phone=5491138141940"/>
            <SocialButton image={ImageInstagram} link="https://www.instagram.com/baumlanus/"/>
            <SocialButton image={ImageFacebook} link="https://www.facebook.com/baumlanus"/>
            <SocialButton image={ImageMaps} link="https://goo.gl/maps/KEcvH4iaj28yGVt1A"/>
            <SocialButton image={ImageWeb} link="https://www.cervezabaum.com/#fabrica"/>
        </ContainerButtons>
    </Container>
    </Page>
}

export default Home;